module.exports = __webpack_public_path__ + "img/meeting_1.89fb38b0.jpg";